import Area, { IArea } from "./Area";
import Application from "../Application";
import { IRouter } from "../runtime/Router";
import ReportingPeriodPage from "../ui/pages/reporting/ReportingPeriodPage";
import ShowReportingPeriodsInteractor from "../interactor/reporting/ShowReportingPeriodsInteractor";
import ReportingPeriodDetailsPage from "../ui/pages/reporting/ReportingPeriodDetailsPage";
import ShowReportingPeriodDetailsInteractor from "../interactor/reporting/ShowReportingPeriodDetailsInteractor";
import RegisteredApplicantDetailsPage from "../ui/pages/applicants/RegisteredApplicantDetailsPage";
import ShowRegisteredApplicantDetailsInteractor from "../interactor/applicants/ShowRegisteredApplicantDetailsInteractor";
import { RoleConstants } from "../common/Constants";

export default class ReportingArea extends Area implements IArea {
  private router: IRouter;
  private application: Application;

  constructor(application: Application, router: IRouter) {
    super();
    this.router = router;
    this.application = application;
  }

  register(params: any) {
    this.router.registerRoutes(
      {
        path: "/reporting-periods",
        page: this.createPage({
          Page: ReportingPeriodPage,
          action: this.showReportingPeriodPage.bind(this)
        }),
        options: {
          secure: true,
          role: [
            RoleConstants.MIK_BO.MIK_ADMIN,
            RoleConstants.MIK_BO.MIK_OSOBLJE,
            RoleConstants.MIK_BO.MIK_OSOBLJE_PDNS
          ]
        }
      },
      {
        path: "/reporting-periods/:reportingPeriodId/details",
        page: this.createPage({
          Page: ReportingPeriodDetailsPage,
          action: this.showReportingPeriodDetailsPage.bind(this)
        }),
        options: {
          secure: true,
          role: [
            RoleConstants.MIK_BO.MIK_ADMIN,
            RoleConstants.MIK_BO.MIK_OSOBLJE,
            RoleConstants.MIK_BO.MIK_OSOBLJE_PDNS
          ]
        }
      },
      {
        path: "/reporting-periods/:reportingPeriodId/registered-applicants/:applicantId/details",
        page: this.createPage({
          Page: RegisteredApplicantDetailsPage,
          action: this.showRegisteredApplicantDetailsPage.bind(this)
        }),
        options: {
          secure: true,
          role: [
            RoleConstants.MIK_BO.MIK_OSOBLJE,
            RoleConstants.MIK_BO.MIK_OSOBLJE_PDNS
          ]
        }
      },
      {
        path: "/reporting-periods/:reportingPeriodId/registered-applicants/:applicantId/details/:tabKey",
        page: this.createPage({
          Page: RegisteredApplicantDetailsPage,
          action: this.showRegisteredApplicantDetailsPageWithTab.bind(this)
        }),
        options: {
          secure: true,
          role: [
            RoleConstants.MIK_BO.MIK_OSOBLJE,
            RoleConstants.MIK_BO.MIK_OSOBLJE_PDNS
          ]
        }
      },
      {
        path: "/reporting-periods/:reportingPeriodId/registered-applicants",
        page: this.createPage({
          Page: ReportingPeriodDetailsPage,
          action: this.showReportingPeriodDetailsPage.bind(this)
        }),
        options: {
          secure: true,
          role: [
            RoleConstants.MIK_BO.MIK_ADMIN,
            RoleConstants.MIK_BO.MIK_OSOBLJE
          ]
        }
      }
    );
  }

  public showReportingPeriodPage() {
    return this.application.container
      .resolve<ShowReportingPeriodsInteractor>("showReportingPeriods")
      .execute();
  }

  public showRegisteredApplicantDetailsPage(params: any) {
    return this.application.container
      .resolve<ShowRegisteredApplicantDetailsInteractor>(
        "showRegisteredApplicantDetails"
      )
      .execute(
        parseInt(params.applicantId, 10),
        parseInt(params.reportingPeriodId, 10)
      );
  }

  public showReportingPeriodDetailsPage(params: any) {
    return this.application.container
      .resolve<ShowReportingPeriodDetailsInteractor>(
        "showReportingPeriodDetails"
      )
      .execute(params.reportingPeriodId);
  }

  public showRegisteredApplicantDetailsPageWithTab(params: any) {
    return this.application.container
      .resolve<ShowRegisteredApplicantDetailsInteractor>(
        "showRegisteredApplicantDetails"
      )
      .execute(
        parseInt(params.applicantId, 10),
        parseInt(params.reportingPeriodId, 10),
        params.tabKey
      );
  }
}
